import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Button, CircularProgress, Alert, Box } from '@mui/material';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import StripeCheckoutSession from '../../../graphql/mutations/StripeCheckoutSession';

const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY || 'pk_live_51OfWdnAC55tlYvchY1VZ2jLepn7jiUefGZlcnd6npWXTGkpITPlyWH2JKM0cHeb6r3GTfBaPLCM3fCCBBPJyHvZP00d7W6HwTr');

export function CheckoutButton({ priceId, buttonProps = {}, children }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClick = () => {
    setLoading(true);
    setError('');

    StripeCheckoutSession.commit({ priceId }).then(({ stripeCheckoutSession }) => {
      const { sessionId, error: stripeError } = stripeCheckoutSession || {};

      if (sessionId) {
        stripePromise.then((stripe) => {
          stripe.redirectToCheckout({ sessionId });
        });
      } else {
        setError(stripeError || t('somethingWentWrong', 'Something went wrong'));
        toast.error(stripeError || t('profile.tabs.subscription.checkout_session_error'));
        setLoading(false);
      }
    }).catch((err) => {
      setError(err.message || t('unexpectedError', 'An unexpected error occurred.'));
      toast.error(err.message || t('unexpectedError', 'An unexpected error occurred.'));
      setLoading(false);
    });
  };

  return (
    <Box sx={{ mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Button
        variant="outlined"
        color="primary"
        disabled={loading}
        onClick={handleClick}
        {...buttonProps}
      >
        {loading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
        {children || t('profile.tabs.subscription.subscribe_button', 'Subscribe')}
      </Button>
    </Box>
  );
}
